export default "__VITE_ASSET__BfknPDYx__";